<template>
  <v-container fluid>
    <v-btn color="primary" small text to="/pending/orders">
      <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
    </v-btn>
    <!-- editor -->
    <editor
      :docCreate="docCreate"
      :copyStatus="copyStatus"
      :initial="dataItem"
      :outsourcedData="outsourcedData"
      @data="save"
    ></editor>
    <!-- end -->
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import Editor from "../_components/view-editor.vue";
export default {
  components: {
    Editor,
  },
  data: () => ({
    dataItem: {},
    outsourcedData: [],
    docCreate: false,
    copyStatus: false,
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true,
    },
  },
  methods: {
    getById(val) {
      const self = this;
      // get record
      this.$store
        .dispatch("get", `/documents/14/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.dataItem = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });

      // get outsourced
      this.$store
        .dispatch("get", `/outsourced-odln/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.outsourcedData = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    save(data) {
      const url = "/documents";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$router.push("/delivery");
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
};
</script>